var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEditThinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1286 2.0357C14.4754 1.68884 15.0378 1.68884 15.3847 2.0357L17.8973 4.54832C18.2441 4.89518 18.2441 5.45759 17.8973 5.80445L7.21601 16.4857L3.44727 16.4857L3.44727 12.717L14.1286 2.0357Z",
    stroke: "#EC5569",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditThinRed);
export default __webpack_public_path__ + "static/media/icon-edit-thin-red.d3760b68cd2086d9d558ff7d5e07a350.svg";
export { ForwardRef as ReactComponent };